var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCz = function SvgCz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-74 0h682.67v512H-74z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(69.38) scale(.94)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e80000",
    d: "M-74 0h768v512H-74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-74 0h768v256H-74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-74 0l382.73 255.67L-74 511.01V0z",
    fill: "#00006f"
  }))));
};
export default __webpack_public_path__ + "assets/626a83dc74f55da0d78c0973cd02513d.svg";
export { SvgCz as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/cz.svg